import React from "react";

const SubEfficeSlash = () => {
  return (
    <svg
      width="12"
      height="14"
      viewBox="0 0 12 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 0H12L7 14H5L7.14286 8H0V6H7.85714L10 0Z"
        fill="var(--business-color)"
      />
    </svg>
  );
};

export default SubEfficeSlash;
